import { useState } from "react";
import { useQuery, useQueryClient } from "react-query";
import { getProducts } from "Requests/Products";

import { validateArrayType } from "Utils/Arrays";
import { createToast } from "Utils/toastFunc";

import {
  ErrorProps,
  ProductsData,
  ProductsProps,
  UseProductsReturn,
} from "./interface";

export const useProducts = ({
  searchBudget = true,
  enableReq,
  initialFilters,
  queryKey = "products",
}: ProductsProps): UseProductsReturn => {
  const [pageSelected, setPageSelected] = useState(1);
  const [enable, setEnable] = useState(enableReq);
  const [filters, setFilters] = useState<Object>(initialFilters || {});

  const { data, isLoading, isError, error } = useQuery<
    ProductsData,
    ErrorProps
  >(
    [queryKey, filters, pageSelected],
    () =>
      getProducts({
        page: pageSelected,
        filters,
        searchBudget,
      }),
    {
      enabled: enable,
      refetchOnWindowFocus: false,
      onError: (errorRes: ErrorProps) => createToast("error", errorRes.message),
    }
  );

  const queryClient = useQueryClient();

  const handleClearData = (initFilters?: Object) => {
    setPageSelected(1);
    queryClient.setQueryData([queryKey, filters, pageSelected], null);
    if (initFilters) return setFilters(initFilters);
    setFilters({});
  };

  const setNewPage = (page: number) => {
    setPageSelected(page);
  };

  const enableData = () => setEnable(true);

  const setProductFilters = (searchFilter: Object) => {
    setFilters({ ...searchFilter });
  };

  return {
    productsList: validateArrayType(data?.data) ? data?.data : undefined,
    loadingProducts: isLoading,
    productsPagination: data?.pagination,
    productsError: isError ? error.message : null,
    pageSelected,
    fetchNewPage: setNewPage,
    setProductFilters,
    enableData,
    handleClearData,
    filters,
  };
};
